<mat-card>
  <img
    [src]="photoSrc"
    [srcset]="photoSrcSet"
    class="w-100"
    [alt]="photo.name"
    (click)="onPhotoClick()"
    appTooltip="Voir la photo"
  />
  <mat-card-actions>
    <div class="d-flex flex-row w-100 align-items-center">
      <mat-checkbox
        *ngIf="enableSelection"
        (change)="selectPhotoChanged($event)"
      ></mat-checkbox>
      <mat-icon
        *ngIf="photo.main"
        color="accent"
        class="mr-1 main-photo"
        appTooltip="Photo principale"
        aria-label="Photo principale"
        >wallpaper</mat-icon
      >
      <span class="card-text" [appTooltip]="photoName">{{ photoName }}</span>
      <span class="spacer"></span>
      <div class="wrap-btn-action">
        <button
          *ngIf="canUpdateProperty && !isFirst"
          mat-icon-button
          color="primary"
          appTooltip="Remonter d'une position"
          (click)="moveOrderUp()"
        >
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <button
          *ngIf="canUpdateProperty && !isLast"
          mat-icon-button
          color="primary"
          appTooltip="Descendre d'une position"
          (click)="moveOrderDown()"
        >
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <button mat-icon-button color="primary" [matMenuTriggerFor]="actions">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent>
    <ul class="menu-actions">
      <li>
        <a [href]="photoImageUrl" [download]="photoFilename"
          ><mat-icon color="primary">cloud_download</mat-icon
          ><span class="text">Télécharger la photo</span></a
        >
      </li>
      <li *ngIf="canUpdateProperty && !photo.main">
        <a (click)="confirmSetAsMainPhoto()"
          ><mat-icon color="primary">wallpaper</mat-icon
          ><span class="text">Définir en photo principale</span></a
        >
      </li>
      <li *ngIf="canUpdateProperty">
        <a (click)="editPhoto()"
          ><mat-icon color="primary">create</mat-icon
          ><span class="text">Modifier la photo</span></a
        >
      </li>
      <li *ngIf="canUpdateProperty">
        <a (click)="changeOrder()"
          ><mat-icon color="primary">low_priority</mat-icon
          ><span class="text">Modifier la position</span></a
        >
      </li>
      <li *ngIf="canUpdateProperty">
        <a (click)="confirmDeletePhoto()">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer la photo</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
